module.exports = __webpack_public_path__ + "media/bootstrap-icons/display-fill-1548a632.svg";